<template>
    <div class="accordion-item">
        <div class="accordion-item__trigger"
             :class="{ 'accordion-item__trigger--active' : active }"
             tabindex="0"
             @keypress.enter="toggleActive"
             @keypress.space.prevent="toggleActive"
             @click="toggleActive">
            <div>
                <slot name="trigger">
                    {{ title }}
                </slot>
            </div>
            <i class="fas fa-chevron-right" />
        </div>
        <transition name="accordion"
                    @enter="start"
                    @after-enter="end"
                    @before-leave="start"
                    @after-leave="end">
            <div v-show="active">
                <div class="accordion-item__content">
                    <slot />
                </div>
            </div>
        </transition>
    </div>
</template>
<script>

export default {
    props: {
        title: {
            type: String,
            required: true,
        },
        open: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            /**
             * @type {boolean}
             */
            active: this.open,
        }
    },

    methods: {
        /**
         * Called when the transition animation begins.
         *
         * @param {HTMLElement} el
         */
        start(el) {
            el.style.height = el.scrollHeight + 'px'
        },

        /**
         * Called when the transition animation ends.
         *
         * @param {HTMLElement} el
         */
        end(el) {
            el.style.height = ''
        },

        /**
         * Toggle the active property and emit the toggle event.
         */
        toggleActive() {
            this.active = !this.active
            this.$emit('toggle', this.active)
            this.$emit(this.active ? 'open' : 'close')
        },
    },
}
</script>
<style lang="scss">

.accordion-item {
    @include element('trigger') {
        position: relative;
        cursor: pointer;
        padding: 0.7rem 1rem;
        transition: color 0.3s ease, background-color 0.3s ease;

        & > .fas {
            transition: 300ms ease all;
            position: absolute;
            right: 1rem;
            top: 1rem;
        }

        @include modifier('active') {
            & > .fas {
                transform: rotate(90deg);
            }
        }
    }

    @include element('content') {
        padding: 0.7rem;
    }
}

// transitions
.accordion-enter-active, .accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
}

.accordion-enter, .accordion-leave-to {
    height: 0 !important;
    opacity: 0;
    overflow: hidden;
}
</style>
